module.exports = __webpack_public_path__ + "img/logo_innobuilder.b7480da0.png";